/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Range_1_MonthInputs */

const en_dashboard_range_1_month = /** @type {(inputs: Dashboard_Range_1_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last month`)
};

const pt_br2_dashboard_range_1_month = /** @type {(inputs: Dashboard_Range_1_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Último mês`)
};

/**
* | output |
* | --- |
* | "Last month" |
*
* @param {Dashboard_Range_1_MonthInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_range_1_month = /** @type {((inputs?: Dashboard_Range_1_MonthInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Range_1_MonthInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_range_1_month(inputs)
	return pt_br2_dashboard_range_1_month(inputs)
});